<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Anexo
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirAnexo"
			hide-footer
		>
			<div slot="modal-title">
				Anexo -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<anexo-form
				:investimento="investimento"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterAnexosAtualizados="$emit('obterAnexosAtualizados')"
			></anexo-form>
		</b-modal>
    </div>
</template>

<script>
import AnexoForm from './AnexoForm'

export default {
	components: {
		AnexoForm
	},

	props: {
		investimento: {
			type: Object,
			default: () => ({})
		}
	},
	
	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
